import React from "react";
import { type UscDispatchType, useUscSelector } from "../../../../../redux/store";
import { getVehicleSaleType } from "../../../../../../shared-logic/utils/uscUtils";
import { UscVehicleSaleType } from "../../../../../../shared-logic/types/UscCommonTypes";
import { showModal } from "../../../../../../../common-deprecated/redux/actions/ModalActions";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import * as Styles from "./BasketVehicleSaleType.styles";
import { MODAL_USC_VEHICLE_SALE_TYPE } from "../../../../../utils/modalConstants";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const saleTypeIcons: Record<UscVehicleSaleType, JSX.Element> = {
    [UscVehicleSaleType.Private]: <Icon variant="profile-ring" />,
    [UscVehicleSaleType.Approved]: <Icon variant="approved" />,
    [UscVehicleSaleType.NonApproved]: <Icon variant="non-approved" />,
};

type BasketVehicleSaleTypeProps = {
    inModal?: boolean;
};

const BasketVehicleSaleType = (props: BasketVehicleSaleTypeProps): JSX.Element | null => {
    const dispatch = useDispatch<UscDispatchType>();
    const { inModal } = props;

    const brand = useUscSelector((state) => state.commonSettings.brand);
    const vehicle = useUscSelector((state) => state.vehicle.result);
    const enablePrivatelySoldVehicles = useUscSelector((state) => state.uscSettings.enablePrivatelySoldVehicles);
    const enableUcProgramBadges = useUscSelector((state) => state.uscSettings.enableUcProgramBadges);
    const customerPromiseBannerItemsAvailable = useUscSelector(
        (state) =>
            !!state.uscSettings.ucProgramCustomerPromiseBanner?.bannerItems?.length &&
            !!state.uscSettings.nonUcProgramCustomerPromiseBanner?.bannerItems?.length,
    );
    const privatelySoldCustomerPromiseBannerItems = useUscSelector(
        (state) => state.uscSettings.privatelySoldCustomerPromiseBanner.bannerItems,
    );
    const commonSettings = useUscSelector((state) => state.commonSettings);

    if (
        !vehicle ||
        !enableUcProgramBadges ||
        // It's a requirement for the modal data to be available in order to show the badge
        !customerPromiseBannerItemsAvailable ||
        (enablePrivatelySoldVehicles && !privatelySoldCustomerPromiseBannerItems?.length)
    )
        return null;

    const { vehicleSaleType, label: vehicleSaleTypeLabel } = getVehicleSaleType(
        vehicle,
        brand,
        enablePrivatelySoldVehicles,
        commonSettings,
    );

    return (
        <Styles.Wrapper
            type="button"
            onClick={() => dispatch(showModal({ type: MODAL_USC_VEHICLE_SALE_TYPE, vehicleSaleType }))}
            disabled={inModal}
        >
            <Styles.Label>
                {saleTypeIcons[vehicleSaleType]}
                {vehicleSaleTypeLabel}
            </Styles.Label>
            {!inModal && (
                <Styles.InfoIconWrapper>
                    <Icon variant="info" />
                </Styles.InfoIconWrapper>
            )}
        </Styles.Wrapper>
    );
};

export default BasketVehicleSaleType;
